import { useContext } from 'react';

import { QBankStructureCVModalContext } from './qbank-structure-cv-modal-provider';

function useQBankStructureCVModal() {
  const context = useContext(QBankStructureCVModalContext);

  if (!context) {
    throw new Error('useQBankStructureCVModal must be used within a QBankStructureCVModalProvider');
  }

  return context;
}

export { useQBankStructureCVModal };
